import { ReactionTriggers } from 'Components/MainStage/index';
import React from 'react';

import { Socket, Event } from 'Services';
import { asset } from 'Services/BaseHelpers';

export default class Reactions extends React.Component {
    /**
     * @var limit
     * @type {integer}
     */
    limit = 25;


    /**
     * @var state
     * @type {{fullscreen: boolean, reactions: *[]}}
     */
    state = {
        reactions: [],
        fullscreen: false,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        this.connectToBroadcasts();

        Event.on('fullscreen', (fullscreen) => {
            this.setState({
                fullscreen,
            });
        });
    };

    /**
     * @method connectToBroadcasts
     */
    connectToBroadcasts = () => {
        Socket.getConnection()
            .private(Socket.channelName(`main_stage_reactions.${this.props.sessionId}`))
            .listen('MainStageReaction', (e) => {
                this.handleAddReaction(e.reaction);
            });
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        Socket.getConnection().leave(Socket.channelName(`main_stage_reactions.${this.props.sessionId}`));
    };

    /**
     * @method handleAddReaction
     * @param {object} reaction
     */
    handleAddReaction = (reaction) => {
        const { reactions } = this.state;
        let offset = (Math.round((Math.random() * 100) + 30) * (Math.PI / 2));

        reactions.push({
            id: reaction.id,
            type: reaction.reaction,
            offset,
            speed: Math.floor(Math.random() * (10 - 5)) + 5,
        });

        if (reactions.length > this.limit) {
            reactions.shift();
        }

        this.setState({
            reactions: reactions,
        });
    };

    /**
     * @method removeReaction
     * @param reaction
     */
    removeReaction = (reaction) => this.setState({
        reactions: this.state.reactions.filter(r => r.id !== reaction.id),
    });

    /**
     * @method renderReaction
     * @param {object} reaction
     * @return {JSX.Element}
     */
    renderReaction = (reaction) => {
        return (
            <img
                key={reaction.id}
                src={asset(`/images/reactions/${reaction.type}.svg`)}
                alt={reaction.type}
                className="absolute w-8 h-8 transition transform-gpu animate-reaction"
                style={{
                    bottom: reaction.offset + 'px',
                    '--speed': reaction.speed + 's',
                }}
                onAnimationEnd={() => this.removeReaction(reaction)}
            />
        );
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { children, side } = this.props;
        const { reactions, fullscreen } = this.state;

        return (
            <div className="relative w-full">
                {children}
                <div
                    className="h-full absolute left-0 right-0 bottom-0 pointer-events-none"
                >
                    {reactions.map(this.renderReaction)}
                </div>
                {fullscreen && (
                    <div className={
                        'sm:absolute top-0 h-full flex flex-row sm:flex-col justify-between sm:justify-start ' +
                        'bg-gray-200 sm:bg-transparent px-4 py-2 sm:p-0 ' +
                        `${side}-0 ${fullscreen ? (side === 'left' ? 'sm:ml-6' : 'sm:mr-6') : (side === 'left' ? 'sm:-ml-6' : 'sm:mr-3')}`
                    }>
                        <ReactionTriggers
                            sessionId={this.props.sessionId}
                        />
                    </div>
                )}
            </div>
        );
    };
}
